const STORAGE_KEY = 'pickingListFilters';

export const STATUS_FILTER_VALUES = ['all', 'in_progress', 'collected', 'deleted'];

const isValidDateInput = (value) => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);

const parseStatusFilter = (data) => {
  if (STATUS_FILTER_VALUES.includes(data?.statusFilter)) {
    return data.statusFilter;
  }
  if (data?.showCollected === true) return 'all';
  if (data?.showCollected === false) return 'in_progress';
  return 'all';
};

export const loadPickingListFilters = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!isValidDateInput(data?.dateFrom)) return null;
    const dateTo = isValidDateInput(data?.dateTo) ? data.dateTo : data.dateFrom;
    return {
      dateFrom: data.dateFrom,
      dateTo,
      statusFilter: parseStatusFilter(data),
    };
  } catch {
    return null;
  }
};

export const savePickingListFilters = ({ dateFrom, dateTo, statusFilter }) => {
  if (!isValidDateInput(dateFrom)) return;
  const to = isValidDateInput(dateTo) ? dateTo : dateFrom;
  const filter = STATUS_FILTER_VALUES.includes(statusFilter) ? statusFilter : 'all';
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        dateFrom,
        dateTo: to,
        statusFilter: filter,
      })
    );
  } catch {
    /* ignore quota / private mode */
  }
};

export const clearPickingListFilters = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
};
